import {
	Button,
	ContentBlock,
	FlexAlign,
	SectionNavigationEntryType,
	Padding,
	SectionNavigation,
	useLayout,
	useTranslation,
	ColourStateSolid,
	SectionNavigationGroup,
} from '@ukpostbox/frontend-framework';
import React, { ForwardedRef, forwardRef } from 'react';
import { useNavigate } from 'react-router';

const SendsNavigation = forwardRef((props: any, ref: ForwardedRef<HTMLDivElement>) => {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();
	const navigate = useNavigate();

	const SendsMenuEntries: Array<SectionNavigationEntryType> = [
		{ title: t('sends.title'), path: '/send-mail/send' },
		{ title: t('sends.profiles.title'), path: '/send-mail/pages' },
		{ title: t('sends.users.title'), path: '/send-mail/users' },
		{ title: t('sends.history.title'), path: '/send-mail/sends' },
		{ title: t('sends.profilesHistory.title'), path: '/send-mail/history' },
	];

	return (
		<SectionNavigation
			ref={ref}
			title={isTiny || isSmall || isMedium ? props.title : t('sends.sendMail')}
			entries={SendsMenuEntries}
			rounded
			addonContent={props.addonContent}
		>
			<SectionNavigationGroup>
				<ContentBlock
					stacked
					title={t('sends.feature.title')}
					content={t('sends.feature.description')}
					media={
						<img
							src={`${process.env.PUBLIC_URL}/images/sends.svg`}
							alt={t('sends.feature.imageAlt')}
							className='text-center'
						/>
					}
					addon={
						<Button
							title={t('sends.feature.button')}
							onClick={() => navigate('/send-mail/create')}
							colour={ColourStateSolid.Secondary}
							fullWidth
						/>
					}
					showBorder
					align={FlexAlign.Start}
					extraClass='text-center mt-md'
					padding={Padding.Large}
				/>
			</SectionNavigationGroup>
		</SectionNavigation>
	);
});

export default SendsNavigation;
